<template>
  <div
    class="card"
    :class="[
      $style.criteriaAuditCard,
      auditDetails.isFutureAudit && isAuditUpNext
        ? $style.isActiveBackground
        : '',
      auditDetails.isFutureAudit && !isAuditUpNext
        ? $style.isFadedBackground
        : '',
    ]"
  >
    <div class="card-content" :class="$style.criteriaAuditCardTop">
      <div class="title padding-top padding-bottom">
        <a
          :class="$style.auditTitle"
          :href="`/audits/` + auditId + `/#dashboard`"
          >{{ auditDetails.name }}</a
        >
      </div>
      <div v-if="auditDetails.startDate">
        <label class="label"
          >{{ dataCollectionStatus === 'notStarted' ? 'Starts' : 'Started' }}
          {{
            auditDetails.startDate ? formatDate(auditDetails.startDate) : 'N/A'
          }}</label
        >
      </div>
      <div v-if="auditDetails.endDate">
        <label class="label"
          >{{ dataCollectionStatus === 'completed' ? 'Ended' : 'Ends' }}
          {{ formatDate(auditDetails.endDate) }}</label
        >
      </div>
    </div>
    <div
      v-if="auditDetails.isFutureAudit && isAuditUpNext"
      class="card-content"
      :class="
        dataCollectionStatus === 'ongoing'
          ? $style.onGoingAuditCardBottom
          : $style.criteriaAuditCardBottom
      "
    >
      <hr :class="$style.hr" />
      <b-button
        tag="router-link"
        :to="`/audits/` + auditId"
        expanded
        v-if="dataCollectionStatus === 'notStarted'"
        :class="$style.configureBtn"
        >Configure</b-button
      >
      <span
        v-if="dataCollectionStatus === 'completed'"
        :class="$style.dataCollectionText"
        >Data Collection Period Completed</span
      >
      <div v-if="dataCollectionStatus === 'ongoing'">
        <p :class="$style.percentageTitle">Data Collected</p>
        <p>0 %</p>
        <progress class="progress is-small is-primary" :value="0" max="100">
          0
        </progress>
      </div>
    </div>
    <div
      v-else-if="!auditDetails.isFutureAudit"
      class="card-content"
      :class="
        dataCollectionStatus === 'ongoing'
          ? $style.onGoingAuditCardBottom
          : $style.criteriaAuditCardBottom
      "
    >
      <hr :class="$style.hr" />
      <span
        v-if="dataCollectionStatus === 'completed'"
        :class="$style.dataCollectionText"
        >Data Collection Period Completed</span
      >
      <div v-if="dataCollectionStatus === 'ongoing'">
        <p :class="$style.percentageTitle">Data Collected</p>
        <p>0 %</p>
        <progress class="progress is-small is-primary" :value="0" max="100">
          0
        </progress>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '@/utils/date.util';
import moment from 'moment';

@Component({ components: {} })
export default class AuditCard extends Vue {
  @Prop()
  public auditDetails: any;

  @Prop()
  public upNextAudit: any;

  public formatDate(s: string) {
    return dayjs(s).format(DATE_FORMAT);
  }

  get auditId() {
    return this.auditDetails.id;
  }

  get isAuditUpNext() {
    return this.upNextAudit && this.upNextAudit.id === this.auditId
      ? true
      : false;
  }

  public redirectToConfigureAudit() {
    this.$router.push({
      name: 'audit-sampling',
      params: {
        auditId: this.auditId.toString(),
      },
    });
  }

  get dataCollectionStatus() {
    if (moment(new Date()).isAfter(this.auditDetails.endDate)) {
      return 'completed';
    } else if (
      this.auditDetails.startedAt ||
      moment(new Date()).isBetween(
        this.auditDetails.startDate,
        this.auditDetails.endDate,
      )
    ) {
      return 'ongoing';
    } else {
      return 'notStarted';
    }
  }
}
</script>
<style lang="scss" module>
.criteriaAuditCard {
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);
  height: 280px;
}
.criteriaAuditCardTop {
  padding: 1rem;
  padding-bottom: 0;
}
.criteriaAuditCardBottom {
  padding-top: 0;
  position: absolute;
  width: 100%;
  bottom: 0;
  height: 87px;
}
.onGoingAuditCardBottom {
  padding-top: 0;
  position: absolute;
  width: 100%;
  bottom: 0;
  height: 110px;
}
.auditTitle {
  color: #00205b;
  font-size: 24px;
  font-weight: 700;
  text-transform: none;
}
.hr {
  margin: 0.5rem 0;
  background-color: #dbdbdb;
  height: 0.5px;
}
.configureBtn,
.configureBtn:hover,
.configureBtn:active {
  background-color: #00205b;
  border-radius: 24px;
  box-shadow: 0 2px 4px 0 rgba(29, 112, 184, 0.33);
  height: 48px;
  color: #ffffff;
  font-size: 18px;
}
.dataCollectionText {
  color: #00205b;
  font-size: 18px;
}
.percentageTitle {
  color: #9e9e9e;
}
.isActiveBackground {
  background-color: #d3f1fc;
}
.isFadedBackground {
  color: #99a6be;
  .auditTitle {
    color: #99a6be;
  }
}
</style>
